import { useFormContext } from "react-hook-form";

export const useMailInput = () => {
  const emailReg =
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
  const { control } = useFormContext();
  return { control, emailReg };
};
